export default {
  hidden_rates:
    'Alguns métodos de pagamento têm também a sua própria taxa, definida pelo suporte da sua plataforma. Essas aplicam-se em vez desta taxa.',
  title: 'Taxas de processamento',
  subtitle: 'A taxa de processamento cobrada a {{company}} nos pagamentos online, para cobrir as taxas da Stripe.',
  card_title: 'Taxa de processamento',
  status: {
    inherited_tag: 'Predefinição do parceiro',
    inherited: 'Este restaurante paga a sua taxa de processamento predefinida.',
    custom_tag: 'Personalizada',
    custom: 'Este restaurante tem a sua própria taxa de processamento, que substitui a predefinida.',
    none_title: 'Não está definida nenhuma taxa de processamento',
    none: 'Nem este restaurante nem a sua predefinição têm uma taxa. A menos que tenha confirmado uma margem de 0% na página de taxas de processamento do parceiro, não pode entrar em funcionamento nem aceitar pagamentos online; com essa confirmação, não lhe é cobrado nada e você paga as taxas do Stripe sobre os respetivos pagamentos.',
  },
  buttons: {
    set_custom: 'Definir taxa personalizada',
    edit: 'Editar',
    cancel: 'Cancelar',
    save: 'Guardar',
    reset_to_default: 'Repor predefinição',
  },
  toasts: {
    load_error: 'Não foi possível carregar a taxa de processamento.',
    failed_to_save_changes: 'Não foi possível guardar a taxa de processamento.',
    changes_got_saved: 'Taxa de processamento guardada',
    reset_to_default: 'Este restaurante passa a usar a sua taxa de processamento predefinida.',
  },
};
